import React from "react";
import styled from "styled-components";
// ... (isti importi za slike)
import ahmed from "../images/team/ahmed.webp";
import tarik from "../images/team/tarik.webp";
import imran from "../images/team/imran.webp";
import sumejja from "../images/team/sumeja.webp";
import logistika from "../images/team/logistika.webp";
import umejr from "../images/team/umejr.webp";
import ajsa from "../images/team/ajsa.webp";
import imranJ from "../images/team/imranJ.webp";
// --- Stilizovane komponente sa Theme bojama ---

const SectionContainer = styled.section`
  padding: 4rem 1rem;
  /* Koristi 'surface' boju iz teme za pozadinu sekcije */
  background-color: ${({ theme }) => theme.colors.surface};
  transition: background-color 0.3s ease; /* Glatka tranzicija boje pozadine */
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Heading = styled.h2`
  font-size: 2.25rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 1rem;
  /* Koristi 'text' boju iz teme */
  color: ${({ theme }) => theme.colors.text};
  transition: color 0.3s ease;
`;

const HeadingSpan = styled.span`
  /* Koristi 'primary' boju iz teme za naglašavanje */
  color: ${({ theme }) => theme.colors.primary};
  transition: color 0.3s ease;
`;

const Description = styled.p`
  text-align: center;
  max-width: 700px;
  margin: 0 auto 3rem;
  /* Koristi 'textSecondary' boju iz teme */
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.1rem;
  transition: color 0.3s ease;
  font-weight: 600;
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;

  /* Mobilni stilovi ostaju isti, ali scrollbar koristi theme boje */
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    /* Koristi breakpoint iz teme */
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    padding-bottom: 1.5rem;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;

    /* Stilovi za scrollbar koriste theme boje */
    scrollbar-width: thin;
    scrollbar-color: ${({ theme }) => theme.colors.primary}
      ${({ theme }) => theme.colors.surface};

    &::-webkit-scrollbar {
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.surface};
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.primary};
      border-radius: 4px;
      border: 2px solid ${({ theme }) => theme.colors.surface};
    }
  }
`;

const TeamMemberCard = styled.div`
  /* Koristi 'background' boju iz teme za pozadinu kartice */
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 12px;
  /* Senka ostaje ista (crna sa providnošću) */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  /* Dodata tranzicija za pozadinu i senku */
  transition: transform 0.3s ease, box-shadow 0.3s ease,
    background-color 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    /* Koristi breakpoint iz teme */
    width: 240px;
    flex-shrink: 0;
    scroll-snap-align: start;
  }
`;

const CardImage = styled.img`
  display: block;
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: center;
`;

const CardContent = styled.div`
  padding: 1.5rem;
  text-align: center;
`;

const Name = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.25rem;
  /* Koristi 'text' boju iz teme */
  color: ${({ theme }) => theme.colors.text};
  transition: color 0.3s ease;
`;

const Title = styled.p`
  font-size: 0.95rem;
  /* Koristi 'primary' boju iz teme za titulu */
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 0 1rem;
  transition: color 0.3s ease;
  font-weight: 700;
`;

/*
// --- Ako vratiš Social ikone, ovako bi ih stilizovao temom ---
const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

const SocialIcon = styled.a`
  color: ${({ theme }) => theme.colors.textSecondary}; // Koristi textSecondary boju
  font-size: 1.25rem;
  transition: color 0.3s ease, transform 0.3s ease;
  display: inline-block;

  svg {
    display: block;
    width: 24px;
    height: 24px;
    fill: currentColor; // Osigurava da SVG koristi boju definisanu u 'a' tagu
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary}; // Koristi primary boju za hover
    transform: scale(1.1);
  }
`;
*/

// --- Podaci (instructors array ostaje isti) ---
const instructors = [
  { name: "Imran Jukić", title: "Mentor Hakatona", image: imranJ },
  { name: "Tarik Faković", title: "Koordinator Hakatona", image: tarik },
  { name: "Ahmed Šusterac", title: "IT Tehničar", image: ahmed },
  {
    name: "Džejlana Dupljak & Lamija Nicevic",
    title: "Logistički koordinatori",
    image: logistika,
  },
  { name: "Imran Zukorlić", title: "PR Specijalista", image: imran },
  {
    name: "Sumejja Hajrović",
    title: "Korporativni Komunikatori",
    image: sumejja,
  },
  { name: "Umejr Zukorlić", title: "IT Tehničar", image: umejr },
  { name: "Ajša Alibašić", title: "HR Specijalista", image: ajsa },
];

// --- Komponenta (JSX ostaje isti) ---
function TeamSection() {
  return (
    <SectionContainer id="team">
      <Container>
        <Heading>
          Naš <HeadingSpan>Tim</HeadingSpan>
        </Heading>
        <Description>
          Upoznajte stručnjake koji će vam biti na usluzi tokom hakatona.
        </Description>

        <CardContainer>
          {instructors.map((instructor, index) => (
            <TeamMemberCard key={index}>
              <CardImage src={instructor.image} alt={instructor.name} />
              <CardContent>
                <Name>{instructor.name}</Name>
                <Title>{instructor.title}</Title>
                {/* Ako dodaš Social ikone, ubaci <SocialLinks> ovde */}
              </CardContent>
            </TeamMemberCard>
          ))}
        </CardContainer>
      </Container>
    </SectionContainer>
  );
}

export default TeamSection;
